import { getAIVoiceModalFilters } from './ai-voice-modal-selectors';
import {
    setAIVoicesRequestFailed,
    setAIVoicesRequestStarted,
    setAIVoicesRequestSucceeded,
    toggleVoiceFavourite,
} from './ai-voice-modal-slice';

import type { AIVoice, AiVoiceV2ListData } from 'js/src/client';
import { ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import { LocalStorageKeys, localStorageRemove, localStorageSet } from 'js/src/libs/local-storage';
import type { AppDispatch, GetRootState } from 'js/src/libs/RootState';
import uuid from 'js/src/libs/uuid';

const parseNextPage = (nextLink: string | null): number | null => {
    if (!nextLink) {
        return null;
    }
    const { search } = new URL(nextLink);
    const queryParams = new URLSearchParams(search);
    const page = queryParams.get('page');
    if (!page) {
        return null;
    }
    const nextPage = parseInt(page, 10);
    return nextPage;
};

export const fetchAIVoiceResults = (query: AiVoiceV2ListData['query'] = {}) => {
    return async (dispatch: AppDispatch) => {
        const requestId = uuid();
        dispatch(setAIVoicesRequestStarted(requestId));

        try {
            const voices: AIVoice[] = [];
            const response = await ApiService.aiVoiceV2List({ query });
            const nextPage = parseNextPage(response.data.next);
            voices.push(...response.data.results);

            dispatch(setAIVoicesRequestSucceeded({ requestId, voices, nextPage }));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            dispatch(setAIVoicesRequestFailed({ requestId, error: String(error) }));
            return false;
        }
    };
};

export const toggleAIVoiceFavourite = (slug: string) => {
    return async (dispatch: AppDispatch) => {
        dispatch(toggleVoiceFavourite(slug));
        try {
            await ApiService.aiVoiceV2ToggleFavouriteCreate({
                body: { slug },
            });
        } catch (error) {
            ErrorReporter.capture(error);
            dispatch(toggleVoiceFavourite(slug));
        }
    };
};

export const saveAIVoiceFiltersToStorage = () => {
    return (_dispatch: AppDispatch, getState: GetRootState) => {
        const { page, ...persisted } = getAIVoiceModalFilters(getState());
        localStorageSet(LocalStorageKeys.AI_VOICE_FILTERS, persisted);
    };
};

export const clearAIVoiceFiltersStorage = () => {
    localStorageRemove(LocalStorageKeys.AI_VOICE_FILTERS);
};
